import React, {useEffect, useMemo, useRef, useState} from 'react';
import TableSkeleton from "../../components/skeletons/TableSkeleton";
import RecordsMessage from "../../components/RecordsMessage";
import DatePicker from "../../components/DatePicker";
import Table from "../../components/Table";
import Pagination from "../../components/Pagination";
import {useToast} from "@chakra-ui/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown, faEllipsisVertical} from "@fortawesome/free-solid-svg-icons";
import {faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
import UtcToLocal from "../../components/UtcToLocal";
import {capitalizeFirstLetters, formatAccount} from "../../features/ValueFormater";
import {useRowSelect, useTable} from "react-table";
import {Checkbox} from "../../components/Checkbox";
import SalesTransactionsAPI from "../../api/salesTransactions";
import ExportButton from "../../components/ExportButton";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import {useOutletContext} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";

function MerchantSoaTemplate({currencyId}) {
    const [GetStatementDataList, SetStatementDataList] = useState([]);
    const [totalNbPage, SetTotalNbPage] = useState(1);
    const [selectedPage, setSelectedPage] = useState(1);
    const [visible, setVisible] = useState(false);
    const [amountDetails, setAmountDetails] = useState(0);

    const {
        GetSalesTransactions,
        salesTransactions,
        totalNbOfPage,
        totalCount,
        salesLoading
    } = SalesTransactionsAPI();

    const [onOpenQrAfterGenerate] = useOutletContext();

    const dispatch = useDispatch();
    const {flag} = useSelector(state => state.transferResponse);

    const [dateRange, setDateRange] = useState([
        new Date(new Date().setMonth(new Date().getMonth() - 1)),
        new Date(),
    ]);

    const [dateString, setDateString] = useState([]);
    const [transactionType, setTransactionType] = useState("All");

    useEffect(() => {
        if (dateRange) {
            const startDate = new Date(Date.UTC(dateRange[0].getUTCFullYear(), dateRange[0].getUTCMonth(), dateRange[0].getUTCDate()));
            const endDate = new Date(Date.UTC(dateRange[1].getUTCFullYear(), dateRange[1].getUTCMonth(), dateRange[1].getUTCDate()));
            const startDateString = startDate.toISOString().substring(0, 10);
            const endDateString = endDate.toISOString().substring(0, 10);
            setDateString({
                startDateString,
                endDateString
            })
            GetSalesTransactions(currencyId, 1, startDateString, endDateString, transactionType);
            setVisible(false);
        }
    }, [dateRange, transactionType, flag]);


    useEffect(() => {
        if (salesTransactions) {
            SetStatementDataList(salesTransactions);
            SetTotalNbPage(totalNbOfPage);
        }
    }, [salesTransactions]);

    const data = useMemo(() => GetStatementDataList, [GetStatementDataList]);

    const [activeRowIndex, setActiveRowIndex] = useState(-1);

    const options = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    };

    const timeOptions = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true

    }

    const handleReverse = (tranID) => {
        dispatch(setActionType(ACTION_TYPES.REVERSE_TRANSACTION));
        dispatch(setActionPayload({TransactionID: tranID}));

        onOpenQrAfterGenerate();
    };

    const columns = useMemo(
        () => [
            {
                Header: "Transaction",
                accessor: "Transaction",
            },
            {
                Header: "",
                accessor: "details",
                Cell: ({row}) => {
                    return <button className="showmore" onClick={() => {
                        setActiveRowIndex(row.index)
                    }}><FontAwesomeIcon icon={faArrowDown}/></button>
                },
            },
            {
                Header: "Payment Date",
                accessor: "PaymentDate",
                Cell: ({cell: {value}}) => {
                    return <UtcToLocal utcTimestamp={value} options={options}/>
                },
            },
            {
                Header: "Payment Time",
                Cell: ({row}) => {
                    return <UtcToLocal utcTimestamp={row.original.PaymentDate} options={timeOptions}/>
                },
            },
            {
                Header: "Type",
                accessor: "Method",
            },
            {
                Header: "Branch",
                accessor: "Branch"
            },
            {
                Header: "Till",
                accessor: "Till"
            },
            {
                Header: "Client",
                accessor: "Client",
                Cell: ({value}) => {
                    return capitalizeFirstLetters(value);
                }
            },
            {
                Header: `Amount (${currencyId === 1 ? "$" : "L.L"})`,
                accessor: "Amount",
                Cell: ({value, row}) => {
                    const sign = row.original.Sign;
                    if (sign === "+") {
                        return <span style={{
                            color: "green",
                            fontFamily: "Poppins Bold ",
                            fontSize: "14px"
                        }}>+{formatAccount(value, currencyId)}</span>;
                    } else if (sign === "-") {
                        return <span style={{
                            color: "red",
                            fontFamily: "Poppins Bold ",
                            fontSize: "14px"
                        }}>-{formatAccount(value, currencyId)}</span>;
                    } else {
                        if(row.original.Status.toUpperCase()?.includes("CANCELED") || row.original.Status.toUpperCase()?.includes("REJECTED")|| row.original.Status.toUpperCase()?.includes("DECLINED") || row.original.Status.toUpperCase()?.includes("TIMED")){
                            return <div style={{"color": "#D32127"}}>{formatAccount(value, currencyId)}</div>
                        }
                        if(row.original.Status.toUpperCase().includes("PENDING")){
                            return <div style={{"color": "#D3AA00"}}>{formatAccount(value, currencyId)}</div>
                        }
                        return formatAccount(value, currencyId);
                    }
                },
            },
            {
                Header: "Status",
                accessor: "Status",
                Cell: ({cell: {value}}) => {
                    value = value?.toUpperCase();
                    if (value?.toUpperCase()?.includes("PENDING")) {
                        return (
                            <span style={{
                                color: "white",
                                fontFamily: "Poppins Medium ",
                                fontSize: "14px",
                                backgroundColor: "#D3AA00",
                                borderRadius: "20px",
                                width: "80%",
                            }}>{capitalizeFirstLetters(value)}</span>
                        );
                    } else if (value?.toUpperCase()?.includes("DECLINED") || value?.toUpperCase()?.includes("REJECTED") || value?.toUpperCase()?.includes("CANCELLED") || value?.toUpperCase()?.includes("CANCELED") || value?.toUpperCase()?.includes("TIMED")) {
                        return <span style={{
                            color: "#D32127",
                            fontFamily: "Poppins Medium ",
                            fontSize: "14px",
                            width: "90%",
                        }}>{capitalizeFirstLetters(value)}</span>;
                    } else if (value?.toUpperCase()?.includes("REVERSED")) {
                        return <span style={{
                            color: "white",
                            fontFamily: "Poppins Medium ",
                            fontSize: "14px",
                            backgroundColor: "#D32127",
                            borderRadius: "20px",
                            width: "80%",
                        }}>{capitalizeFirstLetters(value)}</span>;
                    } else {
                        return <span style={{
                            fontFamily: "Poppins Medium ",
                            fontSize: "14px",
                            backgroundColor: "transparent",
                            borderRadius: "20px",
                            width: "80%",
                        }}>{capitalizeFirstLetters(value)}</span>;
                    }
                },
            },
            {
                Header: "",
                accessor: "Settings",
                Cell: ({row}) => {
                    if (row.original.Status.toLowerCase().includes("pending")) {
                        return <></>
                    }
                    return (
                        <div className="btn-group">
                            {
                                row.original.IsReversible &&
                                <>
                                    <button
                                        type="button"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    ><FontAwesomeIcon id="setingsIcon" icon={faEllipsisVertical}/>
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <button className="dropdown-item cancel-card-btn"
                                                    onClick={() => {
                                                        handleReverse(row.original.Transaction)
                                                    }}
                                            >Reverse Transaction
                                            </button>
                                        </li>
                                    </ul>
                                </>
                            }
                        </div>
                    )
                },
            },
        ],
        []
    );

    const {getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, selectedFlatRows} =
        useTable({columns, data}, useRowSelect,
            (hooks) => {
                hooks.visibleColumns.push((columns) => {
                    return [
                        {
                            id: 'selection',
                            Header: ({getToggleAllRowsSelectedProps}) => (
                                <Checkbox {...getToggleAllRowsSelectedProps()} />
                            ),
                            Cell: ({row}) => (
                                <Checkbox {...row.getToggleRowSelectedProps()} />
                            )
                        },
                        ...columns,
                    ]
                })
            });

    const [searchQuery, setSearchQuery] = useState("");

    const filteredRows = rows.filter((row) => {
        return Object.values(row.original).some((cellValue) => {
            return cellValue.toString().toLowerCase().includes(searchQuery.toLowerCase());
        });
    });

    return (
        <>

            <>
                <div className={activeRowIndex === -1 ? "col-10" : "col-8"}>
                    <div className="tableTop">
                        <RecordsMessage totalCount={totalCount} selectedPage={selectedPage}
                                        records="transactions"/>
                        <div className="filtering">
                            <div className="filteringSearch">
                                <input
                                    className="search"
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                <span className="iconSeacrch"><FontAwesomeIcon icon={faMagnifyingGlass}/></span>
                            </div>

                            <div className="DatePicker">
                                <DatePicker
                                    value={dateRange}
                                    onChange={setDateRange}
                                />
                            </div>
                            <select
                                className="ddselect"
                                name="account"
                                id="account"
                                onChange={(e) => {
                                    setActiveRowIndex(-1)
                                    setVisible(false);
                                    setSelectedPage(1);
                                    setTransactionType(e.target.value);
                                }}
                            >
                                <option value="All">All Transactions</option>
                                <option value="QRPayment">QR Payment</option>
                                <option value="RemotePayment">Remote Payment</option>
                            </select>
                            <ExportButton
                                CurrencyID={currencyId}
                                dateFrom={dateString.startDateString}
                                dateTo={dateString.endDateString}
                                transactionType={transactionType}
                                selectedRows={selectedFlatRows}
                            />
                        </div>
                    </div>
                    {salesLoading ? (
                        <>
                            <TableSkeleton/>
                        </>
                    ) : (
                        <>
                            <Table
                                headerGroups={headerGroups}
                                page={filteredRows}
                                prepareRow={prepareRow}
                                getTableProps={getTableProps}
                                getTableBodyProps={getTableBodyProps}
                                activeRowIndex={activeRowIndex}
                                setActiveRowIndex={setActiveRowIndex}
                                setAmountDetails={setAmountDetails}
                                setVisible={setVisible}
                                disableDetails={true}
                                totalNbPage={totalNbPage}
                            />

                            <Pagination
                                getData={GetSalesTransactions}
                                CurrencyID={currencyId}
                                totalNbPage={totalNbPage}
                                method="soa"
                                endDateString={dateString.endDateString}
                                startDateString={dateString.startDateString}
                                transactionType={transactionType}
                                selectedPage={selectedPage}
                                setSelectedPage={setSelectedPage}
                            />
                        </>
                    )
                    }

                </div>
            </>

        </>
    );
}

export default MerchantSoaTemplate;